import { useEffect } from 'react';
import { useRouter } from 'next/router';

import useSignInRedirect from 'Utilities/hooks/useSignInRedirect';

const useRouterMiddleware = ({ routeChangeStart }) => {
	const router = useRouter();

	const handleRouteChangeStart = (url) => {
		routeChangeStart?.({ url });
	};

	useEffect(() => {
		router.events.on('routeChangeStart', handleRouteChangeStart);

		return () => {
			router.events.off('routeChangeStart', handleRouteChangeStart);
		};
	});
};

const RouterMiddleware = ({ children }) => {
	const { redirectIfNotSignedIn } = useSignInRedirect();

	const routeChangeStart = ({ url }) => {
		redirectIfNotSignedIn(url);
	};

	useRouterMiddleware({ routeChangeStart });

	return children;
};

export default RouterMiddleware;
